import { Component, Output, EventEmitter, OnInit, effect } from '@angular/core';
import { HuddlesService } from 'src/app/shared/services/huddle/huddles.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { CustomFieldRenderer } from 'src/app/shared/services/lw-ui-rule/ltms-custom-field-renderer-v2';
import * as _ from 'lodash'
import * as moment from 'moment';
import { LtmsDataSource } from 'src/app/shared/services/lw-ui-rule/ltms-data-source';
import { LwComponentRenderer } from 'src/app/shared/services/lw-elements-renderer/lw-component-renderer';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { FileUploadService } from 'src/app/shared/services/file-upload/file-upload.service';
import { FeedsService } from 'src/app/shared/services/feeds/feeds.service';
import { LwActionsExecutor } from 'src/app/shared/services/lw-ui-rule/lw-action-executor';
import { LtmsEventHandlerService } from 'src/app/shared/services/ltms-event-handler/ltms-event-handler.service';
import { NgIf } from '@angular/common';
import { OverviewTableComponent } from '../../../../shared/components/score/score-overview/sub-component/overview-table/overview-table.component';
import { DomSanitizer  } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
@Component({
    selector: 'app-huddle-creation',
    templateUrl: './huddle-creation.component.html',
    styleUrls: ['./huddle-creation.component.scss'],
    imports: [NgIf, OverviewTableComponent]
})
export class HuddleCreationComponent implements OnInit {
  @Output() closeSidebar = new EventEmitter<void>();

  // Method to emit the event
  onClose() {
    this.closeSidebar.emit(); // This will trigger the event
  }



  // new variable delcaration;
  brandId: any = null;
  huddleMeetingName: any = null;
  isModuleLoading: boolean = true;
  brandDetails: any = {};
  managerAccessDetail: any = {};
  huddleModulesDetails: any = {};
  moduleBrandIdList: any = [];
  modulesConfigs: any = {}
  brandWiseModuleConfigs: any = {}
  services: any = {}
  isAddButtonEnabled: boolean = true;
  isActionButtonVisible: boolean = false;
  isUpdateButtonEnabled: boolean = false;

  constructor(
    private huddlesService: HuddlesService,
    private _helpers: HelpersService,
    private _stateService: AppStateService,
    private LtmsDataSource: LtmsDataSource,
    private lwComponentRenderer: LwComponentRenderer,
    private _utils: UtilsService,
    private _uploadService: FileUploadService,
    private _feedService: FeedsService,
    private LwActionsExecutor: LwActionsExecutor,
    private _ltmsEvent: LtmsEventHandlerService,
    private _domSanitizer: DomSanitizer
  ) {
    this.services = {
      _helpers: this._helpers,
      LtmsDataSource: this.LtmsDataSource,
      lwComponentRenderer: this.lwComponentRenderer,
      _utils: this._utils,
      _uploadService: this._uploadService,
      _feedService: this._feedService,
      LwActionsExecutor: this.LwActionsExecutor,
      _ltmsEvent: this._ltmsEvent,
      _domSanitizer: this._domSanitizer,
      SecurityContext: SecurityContext
    }
    effect(() => {
      if (this._stateService.initialized()) {
        this.brandDetails = this._stateService.brandDetails()
        if (!_.isEmpty(this.brandDetails)) {
          this.brandId = this.brandDetails._id;
          this.managerAccessDetail = this._helpers.getLoggedInAccessLevelAndValue();
          this.huddleModulesDetails = _.get(this.brandDetails, 'action_management_configuration.huddle.modules');
          if (!_.isEmpty(this.huddleModulesDetails)) {
            this.moduleBrandIdList = _.map(this.huddleModulesDetails, (module: any) => { return _.get(module, 'config.brand_id') });
            var name = _.get(this.brandDetails, "action_management_configuration.huddle.title");
            // Prepare Huddle Name
            this.huddleMeetingName = ((name && name.length) ? name + " - " : "") + ((this.managerAccessDetail && this.managerAccessDetail.value && this.managerAccessDetail.value.length) ? this.managerAccessDetail.value + " - " : "");
            this.huddleMeetingName += moment().format("DD MMM 'YY");

            if (this.moduleBrandIdList && this.moduleBrandIdList.length) {
              this.getBrandListDetails();
            }
          }else{
            console.error("Error huddle configuration not found")
          }

        }
      }
    })
  }


  tableConfigs: any = {
    "spotlights": {
      config: {
        textWrap: true,
        isRowdeletable: true,
      },
      header: []
    },
    "actions": {
      config: {
        textWrap: true,
        isRowdeletable: true,
      },
      header: []
    },
    "escalations": {
      config: {
        textWrap: true,
        isRowdeletable: true,
      },
      header: []
    }
  }

  getBrandListDetails() {
    const queryParams = {
      'brand_id_list': this.moduleBrandIdList,
      'selected_fields': ["field_definitions"]
    };

    this.huddlesService.getBrandListDetails(queryParams).subscribe((response) => {
      if (response && _.get(response, 'data.code') == 0 && !_.isEmpty(response.data.data)) {
        const fieldDefinationMap: any = _.get(response, 'data.data', {})
        _.each(this.huddleModulesDetails, (module: any, modulekey: string) => {
          const brandId: any = _.get(module, 'config.brand_id')
          let moduleConfig = Helpers.deepClone(module)
          moduleConfig.brandId = brandId;
          moduleConfig.field_to_update = modulekey;
          moduleConfig.fieldDefinitions = [];
          if (fieldDefinationMap && _.hasIn(fieldDefinationMap, brandId + '.field_definitions') && !_.isEmpty(fieldDefinationMap[brandId].field_definitions)) {

            let fieldDefinitions: any = _.get(fieldDefinationMap, brandId + '.field_definitions');

            fieldDefinitions = _.filter(fieldDefinitions, function (fieldDefinition) {
              return (_.get(fieldDefinition, "visibility_config.huddle_creation") != false || _.get(fieldDefinition, "parent_field_id")) ? true : false;
            });
            let columns = _.filter(Helpers.deepClone(fieldDefinitions), (field: any) => {
              return (field.group_id != null && _.get(field, 'visibility_config.huddle_creation') != false && _.get(field, 'visibility_config.huddle_creation_list') != false)
            })
            this.tableConfigs[modulekey].header = _.map(columns, (field: any, index: number) => {
              let field_id = field.field_id
              if (_.get(field, 'datasource.options.data_to_save_in.display_field')) {
                field_id = _.get(field, 'datasource.options.data_to_save_in.display_field')
              } else if (_.get(field, 'datasource.options.display_field')) {
                field_id = _.get(field, 'datasource.options.display_field')
              }


              let column: any = {
                header: field.title || field.name,
                uniqueId: field_id,
                field_id: field.field_id,
                width: this.getColumnWidth(field),
                maxWidth: this.getColumnWidth(field),
                minWidth: this.getColumnWidth(field),
                isSortingEnabled: false,
                data_type: field.data_type,
                style: {
                  header: 'flex-start',
                  row: 'flex-start',
                  textWrap: 'wrap'//(_.get(field, 'dom_options.type') == "multi-line") ? 'wrap' : ''
                },
                textStyle: {
                  whiteSpace: 'wrap'//(_.get(field, 'dom_options.type') == "multi-line") ? 'wrap' : ''
                }
              }
              if (field.isSortable) {
                if (field.data_type == "date") {
                  column.sortId = field.field_id + "_in_ms";
                  column.sort_order = 'desc';
                  // this.tableConfigs.defaultSortOnColumn = column;
                }
                column.isSortingEnabled = true;
              }
              return column

            })
            moduleConfig.fieldDefinitions = fieldDefinitions;

            this.modulesConfigs[modulekey] = Helpers.deepClone(moduleConfig);
            this.brandWiseModuleConfigs[brandId] = Helpers.deepClone(moduleConfig);
            this.brandWiseModuleConfigs[brandId].rows = [];
          }
        })
      }else{
        console.warn("Error occured while fetching field definition for brands")
      }
      this.isModuleLoading = false;

    }, (error) => {
      console.error('Error fetching dataset values:', error)
      this.isModuleLoading = false
    });
  }

  getColumnWidth(column: any) {
    if (column.field_id == "tag_meeting_name") {
      return '440px';
    } else if (column.field_id == "tag_ltms_huddle_suggestions_for_process_imporvement_theme_1") {
      return '270px';
    } else if (column.field_id == "tag_ltms_huddle_suggestions_for_process_imporvement_sub_reason_1" || column.field_id == "tag_ltms_huddle_e4147198-670e-4ced-b98e-fc4679f57d8f81-11" || column.field_id == "tag_ltms_huddle_e256eace-6abf-4960-a0ea-ec85abd0addd") {
      return '300px';
    } else if (column.field_id == "tag_ltms_huddle_3082eef8-baba-409d-b05e-99e960d760d889-44") {
      return '120px';
    } else if (column.field_id == "tag_ltms_huddle_82797a2f-616e-4f2f-b4ee-808238baf0e89") {
      return '320px';
    } else if (column.field_id == "tag_ltms_huddle_suggestions_for_process_imporvement_product_and_function_1") {
      return '210px';
    } else if (_.get(column, 'dom_options.type') == "multi-line") {
      return '600px';
    } else if (column.data_type == 'date') {
      return '150px';
    } else {
      return '200px';
    }
  }

  activeTab: string = 'spotlights';
  changeCreationTab(tabName: string) {
    this.activeTab = tabName;
    this.isAddButtonEnabled = true;
    this.isActionButtonVisible = false;
  }

  isFieldRendered: boolean = false;
  initFieldForDataCreation() {
    this.isFieldRendered = false
    const config: any = this.modulesConfigs[this.activeTab];
    var parentGroup = _.filter(config.fieldDefinitions, { "group_id": null });
    parentGroup = (parentGroup && parentGroup.length) ? parentGroup[0] : null;
    var brandId = _.get(config, "config.brand_id");
    if (parentGroup) {
      var groupKey = _.get(parentGroup, "field_id");
      var params = {
        "issueId": " ",
        "brandDetail": { "unique_custom_parameter_id": brandId, "field_definitions": Helpers.deepClone(config.fieldDefinitions) },
        "showSubmit": false,
        "elementId": "huddle_new_accordion_" + brandId,
        "action": {
          "action": "renderOnAccordion",
          "options": {
            "group_id": groupKey
          }
        }
      }
      var ltmsCustomField = new CustomFieldRenderer(params, this.services);
      ltmsCustomField.addEventListener('group-rendered', () => {
        this.isFieldRendered = true;
        this.isAddButtonEnabled = false;
        this.isActionButtonVisible = true;
      })
    }

    this._ltmsEvent.remove('custom-parameter-validate-status-huddle-new');
    this._ltmsEvent.listen('custom-parameter-validate-status-huddle-new', (data) => {
      var huddleConfig = _.get(this.brandWiseModuleConfigs, this.fieldToUpdate);

      if (this.isValidConfig(huddleConfig)) {
        if (_.has(huddleConfig, "rows")) {
          data.data["app_id"] = _.get(this.brandWiseModuleConfigs, this.fieldToUpdate + ".config.app_id");
          data.data["tag_meeting_name"] = this.huddleMeetingName;
          data.data["deletable"] = this.huddleMeetingName;
          this.updateDataForObjectType(data.data, huddleConfig.field_definitions);

          this.brandWiseModuleConfigs[this.fieldToUpdate]["rows"].push(data.data);
          this.isUpdateButtonEnabled = this.hasDataToSave(this.brandWiseModuleConfigs)
          const element: any = document.getElementById("huddle_new_accordion_" + this.fieldToUpdate);
          if (element) {
            element.innerHTML = ''
          }
          this.isFieldRendered = false;
          this.isAddButtonEnabled = true;
          this.isActionButtonVisible = false;
        }
      }

    })

  }

  isValidConfig(config) {
    var validationConfig = _.get(config, "config.validation_rule");
    if (validationConfig) {
      var rows = _.get(config, "rows");
      if (rows && validationConfig['max'] && rows.length < validationConfig['max']) {
        // If number of rows less than max fields
        // Not checking for equal to as the index starts from 0
        return true;
      } else {
        // If number of rows more than max fields
        return false;
      }
    }
    // If no validation conditions then no validation check required
    return true;
  }

  fieldToUpdate: any = null
  updateFieldValues() {
    this.fieldToUpdate = _.get(this.modulesConfigs[this.activeTab], "config.brand_id");

    if (this.fieldToUpdate) {
      // LtmsEventListener.fire("submit-custom-parameter", config);
      this._ltmsEvent.emit("submit-custom-parameter", { "unique_custom_parameter_id": this.fieldToUpdate, "event_to_trigger": ("custom-parameter-validate-status-huddle-new") });
    } else {
      Helpers.smallAlertBox("Warning", 'No brand to update.', "warn", 3500);
    }
  }

  updateDataForObjectType(data: any, fieldDefinitions) {
    var fieldId: any = null;
    var fieldDefinitionMap = this.prepareMap(fieldDefinitions, 'field_id');
    var displayField: any = null;
    var valueField: any = null;
    var nameField: any = null;
    var dataToModify: any = null;

    for (let fieldId in data) {
      // If value of key is an object then we need to check for the pattern to save in
      if (_.isObject(data[fieldId])) {
        dataToModify = data[fieldId];
        // If data has object, get the field definition for the fieldId: This will provide the detail to save data in.
        let fieldDefinition = fieldDefinitionMap[fieldId];
        if (_.get(fieldDefinition, "datasource.options.data_to_save_in") && _.isObject(fieldDefinition.datasource.options.data_to_save_in) && !_.isEmpty(fieldDefinition.datasource.options.data_to_save_in)) {
          // field definition to update for Display field 
          displayField = _.get(fieldDefinition, "datasource.options.data_to_save_in.display_field");
          valueField = _.get(fieldDefinition, "datasource.options.data_to_save_in.value_field");

          data[displayField] = dataToModify[_.get(fieldDefinition, "datasource.options.display_field")];
          data[valueField] = dataToModify[_.get(fieldDefinition, "datasource.options.value_field")];
          // Data to save apart from display field and value field such as name of the manager apart from manager's email address and id
          nameField = _.get(fieldDefinition, "datasource.options.name_field");
          if (nameField) {
            data[valueField] = dataToModify[_.get(fieldDefinition, "datasource.options.name_field")];
          }
        }
      }
    }
  }

  prepareMap(data, key) {
    var dataMap = {};
    _.each(data, function (d) {
      dataMap[d[key]] = d;
    })
    return dataMap;
  }

  hasDataToSave(data) {
    var rowWithData = _.find(data, function (value, key) {
      return (value.enabled && _.get(value, "rows.length")) ? true : false;
    });
    return ((_.isEmpty(rowWithData)) ? false : true);
  }


  removeDataFromList(event: any, brandId: any) {
    this.brandWiseModuleConfigs[brandId].rows.splice(event.index, 1)
    this.isUpdateButtonEnabled = this.hasDataToSave(this.brandWiseModuleConfigs)
  }


  cancelDataCreation() {
    let brandId = _.get(this.modulesConfigs[this.activeTab], "config.brand_id");
    const element: any = document.getElementById("huddle_new_accordion_" + brandId);
    if (element) {
      element.innerHTML = ''
    }
    this.isFieldRendered = false;
    this.isAddButtonEnabled = true;
    this.isActionButtonVisible = false;
  }

  saveHuddleDetails() {
    Helpers.showConfirmationBox("Attention!", "Please confirm that you want to save these changes?", (result: any) => {
      if (result) {
        this.prepareHuddleToUpdate((error: any, params: any) => {
          if (error) {
            Helpers.smallAlertBox("Error", error, "error", 3500);
          } else {
            this.huddlesService.huddleCreate(params).subscribe((response: any) => {
              this.onClose()
              if (_.get(response, "data.code") == 0) {
                Helpers.smallAlertBox("Success", 'Huddle created successfully.', "Success", 3500);
              } else {
                Helpers.smallAlertBox("Error", 'Problem while creating a huddle.', "error", 3500);
              }
            }, () => {
              this.onClose()
              Helpers.smallAlertBox("Error", 'Problem while creating a huddle.', "error", 3500);
            });
          }
        })
      }
    })

  }

  prepareHuddleToUpdate(cb: any) {
    var accessDetail = this._helpers.getLoggedInAccessLevelAndValue();
    if (accessDetail) {
      var paramsToUpdate = {
        // Hard coded for now
        "branch_code": accessDetail.value,
        // brand Id of current brand
        "brand_id": this.brandId,
        "params": {
          "name": this.huddleMeetingName,
          "created_date": new Date(),
          "hierarchy_level": accessDetail.level,
          "hierarchy_value": accessDetail.value,
          "items": {}
        }
      }
      _.each(this.brandWiseModuleConfigs, (module: any, brandId: string) => {
        paramsToUpdate["params"][module.field_to_update] = module["rows"];
      })
      cb(null, paramsToUpdate);
    } else {
      cb("Can't create a huddle as manager doesn't have a dynamic project access.", null);
    }
  }

  clearAllFields() {
    _.each(this.brandWiseModuleConfigs, (module: any, brandId: string) => {
      this.brandWiseModuleConfigs[brandId].rows = [];
    })
    this.isUpdateButtonEnabled = this.hasDataToSave(this.brandWiseModuleConfigs)
  }


  ngOnInit(): void {
    document.addEventListener('keyup', (e) => {
      if (e.key == "Escape") {
        this.onClose()
      }
    });
  }
}
